export class ModalTrackHelper {
	_buildAttributionFeature(featureName, comboType) {
		const comboTypeCase = comboType[0].toUpperCase() + comboType.substring(1).toLowerCase();
		return `${featureName}${comboTypeCase}_ArticleCombinationLayer`;
	}

	_createWidgetPayloadWithNumberOfSimilarCombos(numberOfCombos, comboType, status, position) {
		return {
			id: "combo-SimCombos",
			name: "SimilarCombos",
			position: position,
			status: status,
			labels: {
				promo_FilledSlots: [`${numberOfCombos}`],
				promo_ComboType: [comboType],
				promo_FeatureNumber: ["1"],
				promo_Feature: ["true"]
			}
		};
	}

	_generateClickedComboModalPayload(clickTrackingInfo, hasSimilarityScore) {
		return {
			id: "combo-SimCombo-" + clickTrackingInfo.clickedCombo.position,
			parentId: "combo-SimCombos",
			name: "SimilarCombo",
			position: clickTrackingInfo.clickedCombo.position,
			status: "clicked",
			labels: {
				promo_Content: [clickTrackingInfo.clickedCombo.id],
				promo_Source: [clickTrackingInfo.clickedCombo.comboSource],
				...(hasSimilarityScore && {
					promo_ComboSimilarity: [`${clickTrackingInfo.clickedCombo.similarityScore}`]
				})
			}
		};
	}

	_generateComboTracking(combo, featureName, status, articleCount) {
		const position = 1;
		const parentId = `combo-${featureName}-${position}`;
		const featureNumber = 1;

		return {
			id: parentId,
			name: featureName,
			position: position,
			status: status,
			labels: {
				promo_FeatureNumber: [`${featureNumber}`],
				promo_FilledSlots: [`${articleCount}`],
				promo_Feature: ["true"],
				promo_Content: [combo.getId()],
				promo_Source: [combo.getSource()],
				promo_ComboType: [combo.getComboType()]
			}
		};
	}

	_generateTrackingPayloadForArticle(article, articleNumberFromADS, parentId, featureName, status) {
		const articlePosition = article.getArticlePosition();
		const comingFromThisArticlesADS = article.getId() === articleNumberFromADS;
		return {
			id: `${parentId}-Article-${articlePosition}`,
			parentId: parentId,
			name: `${featureName}-Article`,
			position: Number.parseInt(articlePosition),
			variationId: article.getVariationId(),
			status: status,
			labels: {
				order_ProductOnWishlist: [`${article.getOnWishlist()}`],
				promo_ComingFromThisArticle: [`${comingFromThisArticlesADS}`]
			}
		};
	}

	_generateTrackingPayloadForCombo(combo, featureName, status, articlesToTrack) {
		const articleCount = Number.parseInt(combo.getArticleCount());
		const comboTracking = this._generateComboTracking(combo, featureName, status, articleCount);

		const articleTracking = articlesToTrack.map(article => {
			return this._generateTrackingPayloadForArticle(
				article,
				combo.getArticleNumberFromADS(),
				comboTracking.id,
				featureName,
				status
			);
		});

		return [comboTracking, ...articleTracking];
	}

	_generatePageImpressionSimilarCombosPayload(similarCombos) {
		return similarCombos.getTiles().map((combo, index) => {
			const hasSimilarityScore = combo.getSimilarityScore() !== null;
			return {
				id: "combo-SimCombo-" + (index + 1),
				parentId: "combo-SimCombos",
				name: "SimilarCombo",
				position: index + 1,
				status: "loaded",
				labels: {
					promo_Content: [combo.getComboId()],
					...(hasSimilarityScore && { promo_ComboSimilarity: [`${combo.getSimilarityScore()}`] }),
					promo_Source: [combo.getComboSource()]
				}
			};
		});
	}
}
